<script setup>
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 36">
        <path xmlns="http://www.w3.org/2000/svg"
            d="M22 36L8 28.4V16.4L0 12L22 0L44 12V28H40V14.2L36 16.4V28.4L22 36ZM22 19.4L35.7 12L22 4.6L8.3 12L22 19.4ZM22 31.45L32 26.05V18.5L22 24L12 18.5V26.05L22 31.45Z" />
    </svg>
</template>

<style lang="scss" scoped></style>